import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/auth.service';
import { ApiService } from '../core/api.service';

@Component({
  selector: 'app-signin',
  styles: ['.auth-banner { display: block; width: 100%; max-width: 100%; height: auto; margin: 0 0 6px; }'],
  template: `
  <div class="auth-wrap">
    <div class="auth-card wide">
      <img class="auth-banner" src="assets/header-banner.png" alt="AAA Academy · College Campus Online">
      <div class="auth-narrow">
      <div class="auth-tabs">
        <a class="active">Sign In</a>
        <a routerLink="/signup">Sign Up</a>
      </div>
      <form (ngSubmit)="submit()" #f="ngForm" autocomplete="on">
        <label>Username or Email</label>
        <input name="username" [(ngModel)]="username" required autocomplete="username" autofocus>
        <label>Password</label>
        <div class="pwd">
          <input name="password" [type]="show ? 'text' : 'password'" [(ngModel)]="password" required autocomplete="current-password">
          <button type="button" class="eye" (click)="show = !show">{{ show ? 'Hide' : 'Show' }}</button>
        </div>
        <div class="alert err" *ngIf="error">{{ error }}</div>
        <button class="btn primary block" [disabled]="busy || !f.valid">{{ busy ? 'Signing in…' : 'SIGN IN' }}</button>
      </form>
      <p class="center"><a routerLink="/forgot-password">Forgot password?</a> · <a routerLink="/forgot-username">Forgot username or email?</a></p>
      <p class="center muted small">Don't have an account? <a routerLink="/signup"><b>Register here</b></a> — an admin will approve it.</p>
      </div>
    </div>
  </div>`
})
export class SigninComponent {
  username = '';
  password = '';
  show = false;
  busy = false;
  error = '';

  constructor(private auth: AuthService, private router: Router, private route: ActivatedRoute) {}

  submit() {
    this.busy = true;
    this.error = '';
    this.auth.login(this.username.trim(), this.password).subscribe(
      s => {
        this.busy = false;
        const ret = this.route.snapshot.queryParamMap.get('returnUrl');
        this.router.navigateByUrl(s.mustChangePassword ? '/security/change-password' : (ret || '/dashboard'));
      },
      e => { this.busy = false; this.error = ApiService.message(e, 'Sign in failed.'); }
    );
  }
}
